import { useEffect, useState } from 'react';
import { GetWQSystems } from '../../../_api';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';

const WQSystemSelect = ({ systemID, setSystemID }) => {
	const [options, setOptions] = useState([]);

	useEffect(() => {
		GetWQSystems().then(response => {
			setOptions(response);
		});
	}, []);

	return (
		<>
			<p>Select System</p>
			<Select
				labelId='System_SelectDropdown'
				id='System_SelectDropdown'
				value={systemID}
				label='System'
				onChange={e => setSystemID(e.target.value)}
				name='extensionID'
			>
				<MenuItem key='null_System' value={0}>
					none
				</MenuItem>
				{options
					?.sort((a, b) =>
						a?.Full?.toLowerCase().trim() >
						b?.Full?.toLowerCase().trim()
							? 1
							: -1
					)
					.map(option => {
						return (
							<MenuItem key={option.Id} value={option.Id}>
								{option.Full} ({option.Id})
							</MenuItem>
						);
					})}
			</Select>
		</>
	);
};

export default WQSystemSelect;
